import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { Button } from '@/components/buttons';
import { FieldDescription, FieldGroup } from '@/components/Form/fields';
import { Panel } from '@/components/panels';

import BrandProductAreas from './BrandProductAreas';
import { MAX_PRODUCT_AREAS, useAIVisibilitySettingsForm } from './useAIVisibilitySettingsForm';

type ProductAreasPanelProps = {
  domain: string;
  onSuggest: () => void;
};

const ProductAreasPanel = ({ domain, onSuggest }: ProductAreasPanelProps) => {
  const form = useAIVisibilitySettingsForm();

  return (
    <form.Subscribe
      selector={(state) => ({
        isEmpty: state.values.brandProductAreas.length === 0,
        canAddProductArea: state.values.brandProductAreas.length < MAX_PRODUCT_AREAS,
        isSubmitting: state.isSubmitting,
      })}
    >
      {({ isEmpty, canAddProductArea, isSubmitting }) => {
        const suggestButton = (
          <Button
            className="self-start"
            variant={isEmpty ? 'secondary' : 'ghost'}
            disabled={isSubmitting}
            onClick={onSuggest}
          >
            <Trans>Suggest product areas</Trans>
          </Button>
        );

        return (
          <Panel title={t`Product Areas`}>
            <FieldGroup className={isEmpty ? 'gap-8' : 'gap-2'}>
              {isEmpty && (
                <div className="flex flex-col items-start gap-2">
                  <FieldDescription>
                    <Trans>We can make suggestions by inspecting {domain}</Trans>
                  </FieldDescription>
                  {suggestButton}
                </div>
              )}
              <div className="flex flex-col gap-2">
                {isEmpty && (
                  <FieldDescription>
                    <Trans>You can also add your own</Trans>
                  </FieldDescription>
                )}
                <BrandProductAreas />
                {!isEmpty && canAddProductArea && suggestButton}
              </div>
            </FieldGroup>
          </Panel>
        );
      }}
    </form.Subscribe>
  );
};

export default ProductAreasPanel;
